export const to_b64 = (value) => {
    return Buffer.from(value).toString("base64");
}

export const from_b64 = (value) => {
    return Buffer.from(value, "base64").toString();
}